import { useDispatch, useSelector } from 'react-redux';
import { getRecommendedQuestionsForAgent } from '../widget-data/selectors/getRecommendedQuestionsForAgent';
import { getWidgetLocation } from '../selectors/widgetDataSelectors/getWidgetLocation';
import { getColoring } from '../selectors/widgetDataSelectors/getColoring';
//@ts-expect-error untyped file
import { publishVisitorMessage } from '../pubsub/actions/publishVisitorMessage';
import { loadStagedThread } from '../navigation/actions/loadStagedThread';
import { getKnowledgeBaseEnabled } from '../selectors/widgetDataSelectors/getKnowledgeBaseEnabled';
import { AIPromptRecommendations } from 'conversations-visitor-experience-components/customer-agent/AIPromptRecommendations';
import { toggleOpen } from '../actions/WidgetActions';
import { trackInteraction } from '../usage-tracking/actions/trackInteraction';
import { EVENT_NAMES } from '../usage-tracking/constants/eventNames';
import Raven from 'raven-js';
import ConsentPromptsOutsideChat from 'conversations-visitor-experience-components/visitor-widget/components/ConsentPromptsOutsideChat';
import { useConsentPromptData } from '../hooks/useConsentPromptData';
import { getIsPortal53 } from '../widget-data/operators/getIsPortal53';
import { useCustomerAgentHover } from 'conversations-visitor-experience-components/contexts/CustomerAgentHoverContext';
import { getIsAIChatbot } from '../selectors/widgetDataSelectors/getIsAIChatbot';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AIPromptRecommendationsContainer = ({
  clickedFrom
}) => {
  const dispatch = useDispatch();
  const recommendedQuestionsForAgent = useSelector(getRecommendedQuestionsForAgent);
  const widgetLocation = useSelector(getWidgetLocation);
  const coloring = useSelector(getColoring);
  const knowledgeBaseEnabled = useSelector(getKnowledgeBaseEnabled);
  const {
    isHoverActive
  } = useCustomerAgentHover();
  const isPortal53 = getIsPortal53();
  const isAIChatBot = useSelector(getIsAIChatbot);
  const {
    consentToProcessMessage,
    showGdprConsentToProcessButton,
    showingGdprProcess,
    renderCookieConsentPrompt,
    consentToProcess,
    consentToCookies,
    closeConsentToProcess
  } = useConsentPromptData();
  const handlePromptClick = text => {
    const richText = `<div>${text}</div>`;
    if (knowledgeBaseEnabled) {
      dispatch(loadStagedThread());
    }
    dispatch(publishVisitorMessage({
      text,
      richText
    })).then(() => {
      dispatch(toggleOpen({
        isOpened: true,
        isUser: true,
        openedFrom: 'AI prompt recommendations outside chat'
      }));
    }).catch(() => {
      Raven.captureMessage('Failed to publish message from AI prompt');
    });
  };
  const handlePromptTrack = () => {
    dispatch(trackInteraction(EVENT_NAMES.WIDGET_INTERACTION, {
      action: 'ai prompt recommendation clicked',
      clickedFrom
    }));
  };
  const shouldShowPromptRecommendations = !renderCookieConsentPrompt && !showGdprConsentToProcessButton && (isHoverActive || showingGdprProcess);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AIPromptRecommendations, {
      recommendedQuestionsForAgent: recommendedQuestionsForAgent,
      widgetLocation: widgetLocation,
      coloring: coloring,
      onPromptClick: handlePromptClick,
      onPromptTrack: handlePromptTrack,
      shouldShow: shouldShowPromptRecommendations
    }), isAIChatBot && /*#__PURE__*/_jsx(ConsentPromptsOutsideChat, {
      renderCookieConsentPrompt: renderCookieConsentPrompt,
      showingGdprProcess: showingGdprProcess,
      consentToProcessMessage: consentToProcessMessage,
      showGdprConsentToProcessButton: showGdprConsentToProcessButton,
      consentToProcess: consentToProcess,
      closeConsentToProcess: closeConsentToProcess,
      consentToCookies: consentToCookies,
      isPortal53: isPortal53,
      usageType: "prompt-recommendations"
    })]
  });
};
AIPromptRecommendationsContainer.displayName = 'AIPromptRecommendationsContainer';
export default AIPromptRecommendationsContainer;